import React, { useEffect, useReducer, useState } from 'react';
import { PaletteMode } from '@mui/material';
import * as ACTIONS from '../store/actions/actions';
import { StoreReducer, initialState } from '../store/reducers/storeReducer';

interface AdminContextInterface {
  isAuthenticated: boolean;
  email: string;
  firstName: string;
  lastName: string;
  picture: string;
  idToken: string;
  isClient: boolean;
  clientId: string;
  clientName: string;
  platformId: string;
  platformName: string;
  platformSubdomain: string;
  siteId: string;
  siteSlug: string;
  redirectUrl: string;
  paletteMode: PaletteMode;
  handleSetRedirectUrl: (_data: ACTIONS.SetRedirectProps) => void;
  handleUnsetRedirectUrl: () => void;
  handleUserLogin: (_data: ACTIONS.LoginProps) => void;
  handleUserLogout: () => void;
  handleSelectSite: (_data: ACTIONS.SelectSiteProps) => void;
  handleChangeMode: (_data: ACTIONS.ChangeModeProps) => void;
}

export const defaultProps: AdminContextInterface = {
  isAuthenticated: false,
  email: '',
  firstName: '',
  lastName: '',
  picture: '',
  idToken: '',
  isClient: false,
  clientId: '',
  clientName: '',
  platformId: '',
  platformName: '',
  platformSubdomain: '',
  siteId: '',
  siteSlug: '',
  redirectUrl: '',
  paletteMode: 'light' as PaletteMode,
  handleSetRedirectUrl: (_data: ACTIONS.SetRedirectProps): void => {
    /* noop */
  },
  handleUnsetRedirectUrl: (): void => {
    /* noop */
  },
  handleUserLogin: (_data: ACTIONS.LoginProps): void => {
    /* noop */
  },
  handleUserLogout: (): void => {
    /* noop */
  },
  handleSelectSite: (_data: ACTIONS.SelectSiteProps): void => {
    /* noop */
  },
  handleChangeMode: (_data: ACTIONS.ChangeModeProps): void => {
    /* noop */
  },
};

type AdminProviderProps = {
  children: React.ReactNode;
};

const Context = React.createContext<AdminContextInterface>(defaultProps);

export const AdminProvider: React.FC<AdminProviderProps> = ({ children }) => {
  const [stateStoreReducer, dispatchStoreReducer] = useReducer(
    StoreReducer,
    ACTIONS.hasLocalStore() ? ACTIONS.getLocalStore() : initialState,
  );

  useEffect(() => {
    ACTIONS.setLocalStore(stateStoreReducer);
  }, [stateStoreReducer]);

  return (
    <Context.Provider
      value={{
        handleSetRedirectUrl: (data) => dispatchStoreReducer(ACTIONS.setRedirectUrl(data)),
        handleUnsetRedirectUrl: () => dispatchStoreReducer(ACTIONS.unsetRedirectUrl()),
        handleUserLogin: (data) => dispatchStoreReducer(ACTIONS.login(data)),
        handleUserLogout: () => dispatchStoreReducer(ACTIONS.logout()),
        handleSelectSite: (data) => dispatchStoreReducer(ACTIONS.selectSite(data)),
        handleChangeMode: (data) => dispatchStoreReducer(ACTIONS.changeMode(data)),
        ...stateStoreReducer,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Context;
